import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation,
  inject,
  signal,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NivelObjetivo } from 'modelos/src';
import {
  IJerarquiaAscendenteLuminaria,
  LuminariasHttpService,
} from '../../../../../../auxiliares/servicios/http/luminarias.service';
import { nivelPerfil } from '../../../../../../auxiliares/iconos/iconos';
import { DtCardComponent } from '../../../../../../componentes/detalle/detalle.components';

// Gráfico de la cadena ascendente de jerarquía de UNA luminaria: muestra la
// propia luminaria, sus grupos (por prioridad), su puesta y los grupos de la
// puesta, con el perfil que cada nivel aporta y la prioridad de los grupos.
// Resalta cuál es la FUENTE del perfil efectivo.
@Component({
  selector: 'app-jerarquia-luminaria',
  standalone: true,
  imports: [
    DtCardComponent,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
  ],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './jerarquia-luminaria.component.html',
  styleUrls: ['./jerarquia-luminaria.component.scss'],
})
export class JerarquiaLuminariaComponent implements OnChanges {
  private luminariasService = inject(LuminariasHttpService);

  @Input() idLuminaria?: string;

  cargando = signal(false);
  jerarquia = signal<IJerarquiaAscendenteLuminaria | null>(null);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['idLuminaria']) this.cargar();
  }

  private async cargar(): Promise<void> {
    if (!this.idLuminaria) return;
    this.cargando.set(true);
    try {
      const j = await this.luminariasService.jerarquiaAscendente(
        this.idLuminaria,
      );
      this.jerarquia.set(j);
    } catch (e) {
      console.error(e);
      this.jerarquia.set(null);
    } finally {
      this.cargando.set(false);
    }
  }

  nivelLabel(nivel: NivelObjetivo): string {
    switch (nivel) {
      case 'luminaria':
        return 'Luminaria';
      case 'grupo':
        return 'Grupo de luminarias';
      case 'puesta':
        return 'Puesta';
      case 'grupoPuesta':
        return 'Grupo de puestas';
      default:
        return nivel;
    }
  }

  icono(nivel: NivelObjetivo): string {
    return nivelPerfil(nivel).icon;
  }
}
